import React from 'react';
import { CVSheet } from '../components/cv/CVSheet';
import { ScaledSheet } from '../components/cv/ScaledSheet';
/**
 * The on-screen A4 CV surface (body only). Renders the single condensed CV
 * layout; the Export button lives in the App header and generates a real,
 * text-based PDF from data/cv.ts (see components/cv/pdf) — it does not capture
 * this DOM, so this view is purely for on-screen viewing.
 */
export function CvView() {
  return <div className="cv-view w-full bg-[#efe9e0]" data-id="element-339" data-mp="65bv4m1gu5f9">
      <div className="print-stage flex flex-col items-center px-3 pb-8 pt-6 sm:px-4" data-id="element-340" data-mp="2632xlm2qflt">
        <ScaledSheet data-id="element-341" data-mp="g52noi6guacp">
          <CVSheet compact data-id="element-342" data-mp="g49pi5lkot66" />
        </ScaledSheet>
      </div>
    </div>;
}